import React from 'react';
import { experience } from '../../portfolio';

const Experience = () => {
  return (
    <section className="section">
      <div className="section-header">
        <h1 className="section-title">Professional Experience</h1>
        <p className="section-subtitle">My work history and career progression.</p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
        {experience.map((exp, idx) => (
          <div key={idx} className="list-card" style={{ padding: '32px', background: 'var(--surface)', borderRadius: 'var(--radius)', border: '1px solid var(--border)' }}>
            <div className="list-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
              <h4 style={{ fontSize: '20px', fontWeight: 600, color: 'var(--text-1)', margin: 0 }}>{exp.role}</h4>
              <div style={{ fontSize: '14px', color: 'var(--text-3)', backgroundColor: 'var(--bg)', padding: '6px 12px', borderRadius: '30px', border: '1px solid var(--border)', fontWeight: 500 }}>
                {exp.duration}
              </div>
            </div>
            <div style={{ fontSize: '16px', color: 'var(--text-1)', fontWeight: 500, marginBottom: '20px' }}>{exp.company}</div>
            <ul style={{ paddingLeft: '24px', margin: 0, color: 'var(--text-2)', fontSize: '15px', lineHeight: 1.7 }}>
              {exp.description.map((item, i) => (
                <li key={i} style={{ marginBottom: '8px' }}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Experience;
